function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXml = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m20.42 21.157 2.211 2.211L30 16l-7.369-7.369-2.211 2.212L25.58 16ZM11.58 10.843 9.369 8.631 2 16l7.369 7.369 2.211-2.211L6.42 16ZM17.411 7.677l1.6.437-4.42 16.209-1.6-.437z",
  style: {
    fill: "#f1662a"
  }
}));
export default SvgXml;